import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { t } from '@lingui/macro';
import { Button } from '@decisiv/ui-components';
import Copy from '@decisiv/iconix/lib/components/Copy';
import ClipboardCheck from '@decisiv/iconix/lib/components/ClipboardCheck';

// Matches the toolkit copy button on the Actions page (secondary + rounded).
const RoundedButton = styled(Button)`
  border-radius: 4px;
`;

export default function CopyValueButton({ value = '' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    // Clipboard API is unavailable in non-secure/unsupported contexts; guard
    // for it and swallow rejections so a copy failure can't crash the page.
    if (!navigator.clipboard?.writeText) return;

    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {});
  }, [value]);

  return (
    <RoundedButton
      kind="secondary"
      size="small"
      icon={copied ? ClipboardCheck : Copy}
      text={copied ? t`Copied!` : t`Copy`}
      intent={copied ? 'success' : undefined}
      onClick={handleCopy}
      disabled={!value}
    />
  );
}

CopyValueButton.propTypes = {
  value: PropTypes.string,
};
